import React from "react";
import styles from "./OnboardingStrategy.module.css";
import { cleanLines, stripBoldTitle, splitSentences } from "./utils";

const parseReadiness = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  const body = lines.join(" ").trim();
  const sentences = splitSentences(body);
  return { body, sentences };
};

const ReadinessTargets = ({ markdown = "" }) => {
  const { body, sentences } = parseReadiness(markdown);
  if (!body) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Readiness Targets</h3>
      <div className={styles.summaryCard}>
        <h4 className={styles.summaryTitle}>Target State</h4>
        <p className={styles.summaryText}>What success looks like.</p>
      </div>
      <div className={styles.card}>
        <div className={styles.sectionHeader}>
          <span>OK</span>
          <span className={styles.sectionLabel}>Expected Outcomes</span>
        </div>
        {sentences.length > 1 ? (
          sentences.map((sentence, idx) => (
            <div key={idx} className={styles.bulletRow}>
              <span className={styles.bulletDot} />
              <span>{sentence}</span>
            </div>
          ))
        ) : (
          <p className={styles.paragraph}>{body}</p>
        )}
      </div>
    </div>
  );
};

export default ReadinessTargets;
